<template>
  <section class="section">
    <div class="container">
      <div class="tile is-ancestor">
        <div class="tile is-parent is-4">
          <article class="tile is-child box">
            <p class="title">Schnelle Wiederholungen</p>
            <div class="buttons">


                <span class="button is-info is-fullwidth" v-for="option in options" v-on:click="startTable(option)">{{option.title}} </span>

            </div>
          </article>
        </div>

        <div class="tile is-parent is-4">
          <article class="tile is-child box">
            <p class="title">Textaufgaben</p>
          </article>
        </div>
      </div>


    </div>
  </section>

</template>

<script>
  export default {
    name: "AppHub",
    data() {

      return {
        checkedTable: -1,
        options: [
          {
            title: 'Plus-Tabellen',
            link: {name: 'startArtimeticTables', params: {operation: 1}},
            key: 1

          },
          {
            title: 'Minus-Tabellen',
            link: {name: 'startArtimeticTables', params: {operation: 2}},
            key: 2
          },
          {
            title: 'Multiplizieren',
            link: {name: 'startArtimeticTables', params: {operation: 3}},
            key: 3
          },
          {
            title: 'Teilen',
            link: {name: 'startArtimeticTables', params: {operation: 4}},
            key: 4
          }

        ]

      }
    },
    computed: {},

    methods: {

      startTable: function (number) {
        console.log(number)
        this.$router.push(number.link)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AppHub.vue